
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import ContactForm from './ContactForm';
import ContactSuccess from './ContactSuccess';

interface ContactDialogProps {
  trigger: React.ReactNode;
  title?: string;
  description?: string;
  buttonText?: string;
  type?: 'discovery' | 'demo' | 'contact';
}

const ContactDialog: React.FC<ContactDialogProps> = ({
  trigger,
  title = "Book a Discovery Call",
  description = "Fill out the form below and our team will contact you to schedule a call.",
  buttonText = "Submit",
  type = 'discovery'
}) => {
  const [formSuccess, setFormSuccess] = useState(false);

  const handleFormSuccess = () => {
    setFormSuccess(true);
  };

  const getTitleByType = () => {
    switch (type) {
      case 'discovery': return title || "Book a Discovery Call";
      case 'demo': return title || "Request a Demo";
      case 'contact': return title || "Contact Us";
      default: return title;
    }
  };

  const getDescriptionByType = () => {
    switch (type) {
      case 'discovery': return description || "Fill out the form below and our team will contact you to schedule a call.";
      case 'demo': return description || "Complete this form to schedule a demo of our AI solutions.";
      case 'contact': return description || "Have questions or need assistance? Send us a message and we'll get back to you soon.";
      default: return description;
    }
  };

  const handleDialogOpenChange = (open: boolean) => {
    if (!open) {
      setTimeout(() => {
        setFormSuccess(false);
      }, 300);
    }
  };

  return (
    <Dialog onOpenChange={handleDialogOpenChange}>
      <DialogTrigger asChild>
        {trigger}
      </DialogTrigger>
      <DialogContent className="sm:max-w-[425px] md:max-w-[500px]">
        {!formSuccess ? (
          <>
            <DialogHeader>
              <DialogTitle>{getTitleByType()}</DialogTitle>
              <DialogDescription>
                {getDescriptionByType()}
              </DialogDescription>
            </DialogHeader>
            <ContactForm 
              type={type} 
              buttonText={buttonText} 
              onFormSuccess={handleFormSuccess} 
            />
          </>
        ) : (
          <ContactSuccess />
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ContactDialog;
